if(document.querySelector('.woocommerce-cart-form')){
    var timeout;

    jQuery( function( $ ) {

        $('.woocommerce').on('change', 'input.qty', function(){
            if ( timeout !== undefined ) {
                clearTimeout( timeout );
            }
            timeout = setTimeout(function() {
                $("[name='update_cart']").trigger("click");
            }, 500 ); 
        });

        $('.woocommerce').on('click', '.product-single__quantity-increase', function(e){
            e.preventDefault();
            $(this).prev().val(function(i, oldValue) {
                return ++oldValue;
            });
            $("input.qty").trigger("change");  
        });

        $('.woocommerce').on('click', '.product-single__quantity-decrease', function(e){
            e.preventDefault();
            $(this).next().val(function(i, oldValue) {
                var oldMinusOne = oldValue - 1;
                var newValue = (oldMinusOne < 0) ? 0 : oldMinusOne;
                return newValue;
            });
            $("input.qty").trigger("change");
        });
    } );
}